import { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styles from './index.scss';
import { getPropsToLabelColaboradores } from 'utils/HelpButtonUtils';
import HelpButtonEditEscola from 'components/HelpButton/HelpButtonEditEscola/HelpButtonEditEscola';
import { Container } from '@material-ui/core';
import SnackbarUtils from 'utils/SnackbarUtils';
import { isAuthorizedRequest } from 'utils/httpResponseHandlers';
import { getElementID } from 'utils/HTMLUtils';
import { Col } from 'components/Col';
import { CustomCard } from 'components/CustomCard';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import { Row } from 'components/Row';
import { CustomNumberField } from 'components/CustomNumberField';
import { UnauthorizedScreen } from 'components/UnauthorizedScreen';
import {
  changePeriodoEditingValuePanoramaCoop,
  clearPeriodoEditingCoop,
  loadPeriodoByIdCooperativa,
  loadAnoByIdCooperativa,
  putSavePeriodoCoop,
  postSavePeriodoCoop,
  setEnviarFormularioPeriodo,
} from 'store/modules/EscolasActions';
import useValidationFields from '../../../../../../hooks/useValidationFields';
import { useAtualizarPeriodoAtualDuplicacao } from '../../../../../../hooks/usePeriodo';
import useProgramas from '../../../../../../hooks/useProgramas';
import { TipoPrograma } from 'store/modules/EscolasTypes';

const rootClassName = styles.rootClassName;
const rootElementId = 'cooperativa-escolar-edit';

const INITIAL_STATE = {
  authorizedRequest: true,
  sending: false,
  loading: false,
  ensFundIIProfChanged: false,
  ensFundIIAlunChanged: false,
  ensMedioProfChanged: false,
  ensMedioAlunChanged: false,
  especializadaProfChanged: false,
  especializadaAlunChanged: false,
  colaboradores: false,
  loadingPeriodos: true,
};

const FormDadosCooperativa = ({ id, periodo, idPeriodo, onRefresh, formKey }) => {
  const [state, setState] = useState(INITIAL_STATE);
  const escolas = useSelector((escolasState) => escolasState.escolas);
  const languageValues = useSelector((languageState) => languageState.languages.languageValues);
  const auth = useSelector((authState) => authState.auth);
  const periodoKey = 'periodoEditingCoop';
  const { retornaListaPeriodos, useTituloModal } = useProgramas();
  const { errors, formIsValid, processing } = useValidationFields(escolas, languageValues, periodoKey);
  const enviarFormulario = useSelector((stateReducer) => stateReducer.escolas.enviarFormularioPeriodo);
  const duplicacaoPeriodo = formKey === "duplicar"
  const dispatch = useDispatch();

  const tituloModal = useTituloModal(formKey, TipoPrograma.CooperativaEscolar);

  const loadPeriodo = () => {
    setState((prevState) => ({ ...prevState, loading: true }));
    dispatch(
      loadPeriodoByIdCooperativa(
        idPeriodo,
        () => {
          setState((prevState) => ({
            ...prevState,
            loading: false,
            ensFundIIProfChanged: true,
            ensFundIIAlunChanged: true,
            ensMedioProfChanged: true,
            ensMedioAlunChanged: true,
            especializadaProfChanged: true,
            especializadaAlunChanged: true,
          }));
          loadPeriodos();
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              languageValues.errorLoadPeriodoEditing,
            options: {
              variant: 'error',
            },
          });
        }
      )
    );
  };

  const loadPeriodos = () => {
    dispatch(
      loadAnoByIdCooperativa(
        id,
        () => {
          setState((prevState) => ({ ...prevState, loadingPeriodos: false }));
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              languageValues.errorLoadPeriodosList,
            options: {
              variant: 'error',
            },
          });
        }
      )
    );
  };

  const mensagemEnvio = () => {
    switch (true) {
      case duplicacaoPeriodo:
        return languageValues.successDuplicarPeriodo;
      case editing():
        return languageValues.successSalvarPeriodo;
      default:
        return languageValues.successCadastrarPeriodo;
    }
  };

  const editing = () => {
    return periodo && periodo.length > -1;
  };

  const setValue = (event) => {
    const cuttedName = event.target.name
      .split('Prof')
      .join('')
      .split('Alun')
      .join('');
    let value;
    if (event.target.value === '') {
      value = '';
    } else {
      value = [
        'ensFundII',
        'ensMedio',
        'especializada',
      ].indexOf(cuttedName) > -1
        ? Number(event.target.value)
        : event.target.value;
    }
    setState((prevState) => ({
      ...prevState,
      [event.target.name + 'Changed']: true,
    }));
    dispatch(changePeriodoEditingValuePanoramaCoop(event.target.name, value));
  };

  const toSubmit = () => {
    if (!formIsValid()) {
      return;
    }
    const replaceEmptyWithZero = Object.entries(escolas.periodoEditingCoop).reduce(
      (acc, [key, value]) => ({ ...acc, [key]: value === '' ? 0 : value }),
      {}
    );
    setState((prevState) => ({ ...prevState, sending: true }));
    const postValoresPeriodo = {
      idPeriodo: replaceEmptyWithZero.periodo || idPeriodo,
      colaboradores: replaceEmptyWithZero.colaboradores,
      idEscola: id,
      ensFundIIProf: replaceEmptyWithZero.ensFundIIProf,
      ensFundIIAlun: replaceEmptyWithZero.ensFundIIAlun,
      ensMedioProf: replaceEmptyWithZero.ensMedioProf,
      ensMedioAlun: replaceEmptyWithZero.ensMedioAlun,
      especializadaProf: replaceEmptyWithZero.especializadaProf,
      especializadaAlun: replaceEmptyWithZero.especializadaAlun,
    };

    const putValoresPeriodo = {
      idPeriodo: Number(periodo),
      colaboradores: replaceEmptyWithZero.colaboradores,
      ensFundIIProf: replaceEmptyWithZero.ensFundIIProf,
      ensFundIIAlun: replaceEmptyWithZero.ensFundIIAlun,
      ensMedioProf: replaceEmptyWithZero.ensMedioProf,
      ensMedioAlun: replaceEmptyWithZero.ensMedioAlun,
      especializadaProf: replaceEmptyWithZero.especializadaProf,
      especializadaAlun: replaceEmptyWithZero.especializadaAlun,
    };

    if (editing() && !duplicacaoPeriodo) {
      dispatch(
        putSavePeriodoCoop(
          idPeriodo,
          putValoresPeriodo
        )(
          () => {
            SnackbarUtils.enqueueSnackbar({
              message: mensagemEnvio(),
              options: {
                variant: 'success',
              },
            });
            setState((prevState) => ({ ...prevState, sending: false }));
            retornaListaPeriodos(id, TipoPrograma.CooperativaEscolar, true);
            onRefresh()
          },
          (error) => {
            if (isAuthorizedRequest(error.response)) {
              SnackbarUtils.enqueueSnackbar({
                message:
                  error.response.statusText ||
                  (editing()
                    ? languageValues.erroSalvarPeriodo
                    : languageValues.erroCadastrarPeriodo),
                options: {
                  variant: 'error',
                },
              });
              setState((prevState) => ({ ...prevState, sending: false }));
            } else {
              setState((prevState) => ({
                ...prevState,
                sending: false,
                authorizedRequest: false,
              }));
            }
            retornaListaPeriodos(id, TipoPrograma.CooperativaEscolar, true);
            onRefresh()
          }
        )
      );
    } else {
      dispatch(
        postSavePeriodoCoop(
          postValoresPeriodo,
          () => {
            SnackbarUtils.enqueueSnackbar({
              message: duplicacaoPeriodo
                ? languageValues.successDuplicarPeriodo
                : languageValues.successCadastrarPeriodo,
              options: {
                variant: 'success',
              },
            });
            setState((prevState) => ({ ...prevState, sending: false }));
            retornaListaPeriodos(id, TipoPrograma.CooperativaEscolar, true);
            onRefresh()
          },
          (error) => {
            if (isAuthorizedRequest(error.response)) {
              SnackbarUtils.enqueueSnackbar({
                message:
                  error.response.statusText ||
                  (duplicacaoPeriodo()
                    ? languageValues.erroDuplicarPeriodo
                    : languageValues.erroCadastrarPeriodo),
                options: {
                  variant: 'error',
                },
              });
              setState((prevState) => ({ ...prevState, sending: false }));
            } else {
              setState((prevState) => ({
                ...prevState,
                sending: false,
                authorizedRequest: false,
              }));
            }
            retornaListaPeriodos(id, TipoPrograma.CooperativaEscolar, true);
            onRefresh()
          }
        )
      );
    }
  };

  const getCompletedLabels = (isProf) => {
    return [
      languageValues[
      'ensinoFundamentalII' + (isProf ? 'Prof' : 'Alun') + 'LabelCoop'
      ],
      languageValues['ensinoMedio' + (isProf ? 'Prof' : 'Alun') + 'LabelCoop'],
      languageValues[
      'escolaEspecializada' + (isProf ? 'Prof' : 'Alun') + 'LabelCoop'
      ],
    ];
  };

  const getValueTypes = () => {
    return [
      'ensFundII',
      'ensMedio',
      'especializada',
    ];
  };

  const getPeriodos = () => {
    return escolas.periodoEditingCoop.periodosList.map((p) => ({
      value: formKey === "editar" ? p.nomPeriodo : p.id,
      label: p.nomPeriodo.split('-').join('/'),
      disabled: (!editing() || duplicacaoPeriodo) ? p.flgStatus > 0 : false,
    }));
  };

  useAtualizarPeriodoAtualDuplicacao(duplicacaoPeriodo, 'coop');

  useEffect(() => {
    if (editing()) {
      if (auth.userPermissions.escolas.dadosDaEscola.edit) {
        loadPeriodo();
      } else {
        setState((prevState) => ({ ...prevState, authorizedRequest: false }));
      }
    } else {
      if (auth.userPermissions.escolas.dadosDaEscola.register) {
        loadPeriodos();
      } else {
        setState((prevState) => ({ ...prevState, authorizedRequest: false }));
      }
    }

    return () => {
      dispatch(clearPeriodoEditingCoop());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id, periodo, auth, languageValues]);

  useEffect(() => {
    if (enviarFormulario) {
      toSubmit();
      dispatch(setEnviarFormularioPeriodo(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enviarFormulario, dispatch]);

  return state.authorizedRequest ? (
    <Container
      style={{
        marginTop: 0,
        padding: 0
      }}>
      <CustomCard
        CardPropTypes={{
          className:
            rootClassName + '-card'
        }}
        CardHeaderPropTypes={{
          title: (
            <div className="custom-title-wrapper">
              <span className="custom-title-text">
                {`${tituloModal} de dados do ano do programa Cooperativas Escolares`}
              </span>
              <span className="custom-title-sub">
                Informe os dados anuais do programa
              </span>
            </div>
          )
        }}
        titleHint={languageValues.dadosDaEscolaEditHint}
        sending={state.sending || state.loading}
      >
        <form
          onSubmit={(event) => {
            event.preventDefault();
            toSubmit();
          }}
        >
          <Row>
            <Col cols={[12, 6, 6, 6, 6]}>
              <NewAutoCompleteField
                id={getElementID(rootElementId, 'periodo')}
                label={languageValues.ano}
                placeholder={
                  escolas.periodoEditingCoop.loadingPeriodosList
                    ? languageValues.loadingPeriodos
                    : 'Selecionar o Ano'
                }
                options={getPeriodos()}
                value={escolas.periodoEditingCoop.periodo || ''}
                onChange={(value) => {
                  const currValue = value && value.value > '' ? value.value : '';
                  setValue({
                    target: {
                      name: 'periodo',
                      value: currValue,
                    },
                  });
                }}
                loading={escolas.periodoEditingCoop.loadingPeriodosList}
                loadingMessage={languageValues.loadingPeriodos}
                disabled={(editing() || duplicacaoPeriodo || processing() || state.loadingPeriodos)}
              />
            </Col>

            <Col cols={[12, 6, 6, 6, 6]}>
              <CustomNumberField
                id={getElementID(rootElementId, 'colaboradores')}
                disabled={processing()}
                onlyInteger={true}
                onlyPositive={true}
                label={
                  <Fragment>
                    {languageValues.colaboradores}
                    <HelpButtonEditEscola
                      text={languageValues.hintColaboradoresEscolaEdit}
                      {...getPropsToLabelColaboradores()}
                    />
                  </Fragment>
                }
                name={'colaboradores'}
                value={escolas.periodoEditingCoop.colaboradores}
                onChange={setValue}
                onBlur={(event) => {
                  if (event.target.value === '') {
                    setValue({ target: { name: event.target.name, value: 0 } });
                  }
                }}
              />
            </Col>
          </Row>
          {getValueTypes().map((type, index) => {
            const isEscolaEspecializadaProfLabel =
              type === 'especializada' && 'isProf';
            return (
              <Row key={index}>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomNumberField
                    id={getElementID(rootElementId, type + '-professor')}
                    disabled={processing()}
                    onlyInteger={true}
                    onlyPositive={true}
                    label={
                      <Fragment>
                        {getCompletedLabels(true)[index]}
                        {isEscolaEspecializadaProfLabel && (
                          <HelpButtonEditEscola
                            text={languageValues.hintEducacaoInfantilProfLabel}
                            {...getPropsToLabelColaboradores()}
                          />
                        )}
                      </Fragment>
                    }
                    name={type + 'Prof'}
                    value={escolas.periodoEditingCoop[type + 'Prof']}
                    onChange={setValue}
                    onBlur={(event) => {
                      if (event.target.value === '') {
                        setValue({ target: { name: event.target.name, value: 0 } });
                      }
                    }}
                    error={errors[type + 'Prof']}
                  />
                  {errors[type + 'Prof'] && (
                    <div className="error-message">
                      {errors[type + 'Prof']}
                    </div>
                  )}
                </Col>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomNumberField
                    id={getElementID(rootElementId, type + '-aluno')}
                    disabled={processing()}
                    onlyInteger={true}
                    onlyPositive={true}
                    label={getCompletedLabels()[index]}
                    name={type + 'Alun'}
                    value={escolas.periodoEditingCoop[type + 'Alun']}
                    onChange={setValue}
                    onBlur={(event) => {
                      if (event.target.value === '') {
                        setValue({ target: { name: event.target.name, value: 0 } });
                      }
                    }}
                    error={errors[type + 'Alun']}
                  />
                  {errors[type + 'Alun'] && (
                    <div className="error-message">
                      {errors[type + 'Alun']}
                    </div>
                  )}
                </Col>
              </Row>
            );
          })}
          <Row className="containerRow" />
        </form>
      </CustomCard>
    </Container>
  ) : (
    <UnauthorizedScreen />
  );
}

export default FormDadosCooperativa;
